// Use $ instead of $ without replacing global $
(function ($) {
  $(document).ready(function () {
    $(window).scroll(function () {
      // console.log($(this).scrollTop());

      // two-col-image pattern
      if ($(".redesign22.solutions").length > 0) {
        var top = 1495;
        var top1 = 2196;
      } else {
        var top = 805;
        var top1 = 1743;
      }
      if ($(".two-col-image").length > 0) {
        if ($(this).scrollTop() > top) {
          $(".two-col-image").addClass("animate-complete we-animate");
        } else {
          $(".two-col-image").removeClass("animate-complete animate-pattern");
        }

        if ($(this).scrollTop() > top1) {
          $(".two-col-image").addClass("animate-pattern");
        } else {
          $(".two-col-image").removeClass("animate-pattern");
        }
      }

      // voice-external-box pattern
      if ($(".voice").length > 0) {
        var v_top = 7485.5;
      } else {
        var v_top = 1938;
      }

      if ($(".voice-external-box").length > 0) {
        if ($(this).scrollTop() > v_top) {
          $(".voice-external-box").addClass("animate-complete");
        } else {
          $(".voice-external-box").removeClass("animate-complete");
        }
      }

      // col-with-video pattern
      if ($(".metaverse").length > 0) {
        var top = 2150;
      } else {
        var top = 3140;
      }
      if ($(".col-with-video").length > 0) {
        if ($(this).scrollTop() > top) {
          $(".col-with-video").addClass("animate-complete");
        } else {
          $(".col-with-video").removeClass("animate-complete");
        }
      }

      // col-two-video pattern
      var col_two_top = 260;
      if ($(".col-two-video").length > 0) {
        if ($(this).scrollTop() > col_two_top) {
          $(".col-two-video").addClass("animate-complete");
        } else {
          $(".col-two-video").removeClass("animate-complete");
        }
      }

      // col-three-grid pattern
      if ($(".col-three-grid").length > 0) {
        if ($(this).scrollTop() > 1332) {
          $(".col-three-grid").addClass("animate-complete");
        } else {
          $(".col-three-grid").removeClass("animate-complete");
        }

        if ($(this).scrollTop() > 2220) {
          $(".col-three-grid").addClass("animate-pattern");
        } else {
          $(".col-three-grid").removeClass("animate-pattern");
        }
      }

      // accordion pattern 
      if ($(".redesign22.solutions").length > 0) {
        var acc_top = 4611;
      } else if ($(".faq").length > 0) {
        var acc_top = 1316;
      } else {
        var acc_top = 4632;
      }

      if ($(".accordion").length > 0) {
        if ($(this).scrollTop() > acc_top) {
          $(".accordion").addClass("animate-complete");
        } else {
          $(".accordion").removeClass("animate-complete");
        }
      }

      // resource-grid pattern
      if ($(".solutions-detail").length > 0) {
        var top = 4017;
      } else if ($(".why-veriverse").length > 0) {
        var top = 3946;
      } else {
        var top = 3050;
      }

      if ($(".resource-grid").length > 0) {
        if ($(this).scrollTop() > top) {
          $(".resource-grid").addClass("animate-complete");
        } else {
          $(".resource-grid").removeClass("animate-complete");
        }
      }

      // content-with-img pattern
      if ($(".content-with-img").length > 0) {
        if ($(this).scrollTop() > 1120) {
          $(".content-with-img").addClass("animate-complete");
        } else {
          $(".content-with-img").removeClass("animate-complete");
        }
      }

      // intro-with-icon pattern
      if ($(".ua-safari").length > 0) {
        // For Safari Hide iframe value
        // var intro_top = 450;
        // var intro_top1 = 2339;
        var intro_top = 450;
        var intro_top1 = 3443;
      } else {
        var intro_top = 450;
        var intro_top1 = 3443;
      }

      if ($(".intro-with-icon").length > 0) {
        if ($(this).scrollTop() > intro_top) {
          $(".intro-with-icon").addClass("we-animate");
        } else {
          $(".intro-with-icon").removeClass("we-animate");
        }

        if ($(this).scrollTop() > intro_top1) {
          $(".intro-with-icon").addClass("animate-complete");
        } else {
          $(".intro-with-icon").removeClass("animate-complete");
        }
      }

      // quote-slider pattern
      if ($(".ua-safari").length > 0) {
        // var quote_top = 5120;
        var quote_top = 3235;
      } else if ($(".redesign22.solutions").length > 0) {
        var quote_top = 3350;
      } else if ($(".redesign22.industries").length > 0) {
        var quote_top = 3344;
      } else if ($(".redesign22.custom-voice").length > 0) {
        var quote_top = 7606;
      } else {
        var quote_top = 3235;
      }

      if ($(".quote-slider").length > 0) {
        if ($(this).scrollTop() > quote_top) {
          $(".quote-slider").addClass("animate-complete");
        } else {
          $(".quote-slider").removeClass("animate-complete");
        }
      }

      // card-grid pattern
      if ($(".card-grid").length > 0) {
        var card_grid_top = 2750;
      }

      if ($(".card-grid").length > 0) {
        if ($(this).scrollTop() > card_grid_top) {
          $(".card-grid").addClass("animate-complete");
        } else {
          $(".card-grid").removeClass("animate-complete");
        }
      }

      // logo-grid pattern
      if ($(".why-veriverse").length > 0) {
        var logo_grid_top = 3549;
      }if ($(".homepage").length > 0) {
        // Removed homepage condition if preview blade added
        var logo_grid_top = 3550;
      } else {
        var logo_grid_top = 4044;
      }

      if ($(".logo-grid").length > 0) {
        if ($(this).scrollTop() > logo_grid_top) {
          $(".logo-grid").addClass("animate-complete");
        } else {
          $(".logo-grid").removeClass("animate-complete");
        }
      }

      if ($(".footer-pattern").length > 0) {
        if ($(this).scrollTop() > 330) {
          $("footer").addClass("animate-complete");
        } else {
          $("footer").removeClass("animate-complete");
        }
      }
    });
  });

  $(window).on("load", function () {
    if ($(".banner").length > 0) {
      $(".banner").addClass("animate-complete");
    }

    if ($(".resource-card").length > 0) {
      $(".resource-card").addClass("animate-complete");
    }

    if ($(".content-with-form").length > 0) {
      $(".content-with-form").addClass("animate-complete");
    }
    if ($(".banner-404").length > 0) {
      $(".banner-404").addClass("animate-complete");
    }
  });
})(jQuery);
